function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#fff;}.b{fill:#282828;}"));

var _ref2 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M33.53,16.77a2.79,2.79,0,0,0-2.79,2.79V36.33a2.81,2.81,0,0,0,2.79,2.8h0a2.81,2.81,0,0,0,2.8-2.8V19.56A2.79,2.79,0,0,0,33.53,16.77Z"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  className: "a",
  d: "M22.35,16.77a2.79,2.79,0,0,0-2.79,2.79V36.33a2.81,2.81,0,0,0,2.79,2.8h0a2.81,2.81,0,0,0,2.8-2.8V19.56A2.79,2.79,0,0,0,22.35,16.77Z"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  className: "b",
  d: "M27.94,0a28,28,0,1,0,28,28A27.95,27.95,0,0,0,27.94,0Zm8.39,36.33a2.81,2.81,0,0,1-2.8,2.8h0a2.81,2.81,0,0,1-2.79-2.8V19.56a2.8,2.8,0,0,1,5.59,0Zm-11.18,0a2.81,2.81,0,0,1-2.8,2.8h0a2.81,2.81,0,0,1-2.79-2.8V19.56a2.8,2.8,0,0,1,5.59,0Z"
});

const SvgPause = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 55.9 55.9",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref, _ref2, _ref3, _ref4);

const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgPause, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/pause.5456c544.svg";
export { ForwardRef as ReactComponent };